import { format, parseISO } from 'date-fns';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { Organizer } from 'modules/organizer/domain/interfaces/organizer';
import React, { useCallback, useMemo, useState } from 'react';
import TournamentDropdownMenu from '../tournament-dropdown-menu';
import TournamentHeader from '../tournament-header';
import * as S from './styles';

type UDMenuTournamentsProps = {
  className?: string;
  isOrganizerLoading: boolean;
  organizerInfo: Organizer | null;
};

const UDMenuTournaments = React.memo((props: UDMenuTournamentsProps) => {
  const [isOpen, setIsOpen] = useState(() => {
    const savedState = localStorage.getItem('tournamentMenuOpen');
    return savedState ? JSON.parse(savedState) : false;
  });

  const recentlyAdded = useMemo(() => {
    return props.organizerInfo?.latestTournaments.map((item) => {
      const { id, name, startDate, endDate } = item;

      const startYear = startDate ? format(parseISO(startDate), 'yyyy') : null;
      const endYear = endDate ? format(parseISO(endDate), 'yyyy') : null;
      const dates = [startYear];

      if (endYear && endYear !== startYear) {
        dates.push(endYear);
      }

      return {
        link: Pages.TOURNEYS.builders.edit(id),
        checkPath: Pages.TOURNEYS.builders.edit(id, '*'),
        label: `${name} ${dates.join('/')}`,
      };
    });
  }, [props.organizerInfo?.latestTournaments]);

  const showRecentlyAdded = useMemo(() => {
    return !Array.isArray(recentlyAdded) || recentlyAdded.length > 0;
  }, [recentlyAdded]);

  const toggleOpen = useCallback(() => {
    const newState = !isOpen;
    setIsOpen(newState);
    localStorage.setItem('tournamentMenuOpen', JSON.stringify(newState));
  }, [isOpen]);

  return (
    <S.MenuMainNavigation className={props.className}>
      <TournamentHeader
        showRecentlyAdded={showRecentlyAdded}
        isOpen={isOpen}
        onClick={toggleOpen}
        hasRecentlyAdded={Boolean(recentlyAdded?.length)}
      />
      {showRecentlyAdded && (
        <TournamentDropdownMenu
          recentlyAdded={recentlyAdded ?? []}
          isOpen={isOpen}
          loading={!Boolean(props.organizerInfo) || props.isOrganizerLoading}
        />
      )}
    </S.MenuMainNavigation>
  );
});

export default UDMenuTournaments;
